<template>
    <article>
        <p>
            Coroot uses metrics gathered by the
            <a href="https://github.com/kubernetes/kube-state-metrics" target="_blank" rel="noopener noreferrer">kube-state-metrics</a> exporter
            to combine individual containers into applications.
        </p>

        <CodeSnippet>
        <pre v-hl.sh>
helm repo add prometheus-community https://prometheus-community.github.io/helm-charts
helm repo update
helm install kube-state-metrics -n monitoring --create-namespace prometheus-community/kube-state-metrics --set extraArgs='{--metric-labels-allowlist=pods=[*]}'
        </pre>
        </CodeSnippet>

        <p>
            Other installation options can be found <a href="https://github.com/kubernetes/kube-state-metrics" target="_blank" rel="noopener noreferrer">here.</a>
        </p>
    </article>
</template>

<script>

export default {
    components: {}

}
</script>

<style scoped>
</style>
